import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import React from "react";

import { cn } from "../cn";

export function RadioGroup({ className, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return <RadioGroupPrimitive.Root data-slot="radio-group" className={cn("tw-grid tw-gap-3", className)} {...props} />;
}

export function RadioGroupItem({ className, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        "tw-flex tw-aspect-square tw-size-4 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-border tw-bg-input tw-text-primary tw-shadow-xs tw-outline-none tw-transition-[color,box-shadow]",
        "focus-visible:tw-border-ring focus-visible:tw-ring focus-visible:tw-ring-ring/50 disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
        className,
      )}
      {...props}
    >
      {/* eslint-disable-next-line tailwindcss/enforces-shorthand -- size-* shorthand collapses the radio dot */}
      <RadioGroupPrimitive.Indicator data-slot="radio-group-indicator" className="tw-relative tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center">
        {/* eslint-disable-next-line tailwindcss/enforces-shorthand -- keep explicit h-2/w-2 */}
        <span className="tw-absolute tw-left-1/2 tw-top-1/2 tw-h-2 tw-w-2 tw-shrink-0 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-rounded-full tw-bg-primary" style={{ borderRadius: "9999px" }} />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}
